// import React, { useState } from 'react';
// import SideNav, { Toggle, Nav, NavItem, NavIcon, NavText } from '@trendmicro/react-sidenav';
// import { useHistory } from 'react-router-dom';
// import { Collapse } from 'react-bootstrap';
// // import './Layout.css'; // Import your layout styles

// const Layout = () => {
//   const [selected, setSelected] = useState("dashboard");
//   const history = useHistory();
//   const [isUsermanagementOpen, setIsUsermanagementOpen] = useState(false);

//   const handleSelect = (selectedItem) => {
//     setSelected(selectedItem);
//     switch (selectedItem) {
//         case 'dashboard':
//             history.push('/home');
//             break;
//         case 'expense':
//             // Navigate to the home page
//             history.push('/cate');
//             break;
//         case 'credential':
//             // Navigate to the payment credential page
//             history.push('/Adminsupplier-master');
//             break;
//         case 'location':
//             // Navigate to the payment location page
//               history.push('/RawMaterial-master');
//               break;
//         case 'subscription':
//             history.push('/expense-log');
//             break;
//         case 'paymode':
//             history.push('/paymode-status-master');
//             break;
//         case 'credituser':
//             history.push('/creditUser');
//             break;
//         case 'createemp':
//             history.push('/employee-master');
//             break;
//         case 'createrol':
//             history.push('/role-master');
//             break;
//         default:
//             break;
//     }
// };


//   return (
//     <div className="layout">
//       <SideNav onSelect={handleSelect} style={{ backgroundColor: "#000" }} className="sidebar">
//         <SideNav.Toggle />
//         <SideNav.Nav>
//         <NavItem eventKey="dashboard">
//                     <NavIcon>
//                         <i className="bi bi-house" style={{ fontSize: '1.50em' }} />
//                     </NavIcon>
//                     <NavText style={{ fontSize: '0.9em', fontFamily: "serif", fontWeight: "bold", padding: '2px 0',margin:"0px" }}>
//                         DASHBOARD
//                     </NavText>
//                 </NavItem>
//         <NavItem eventKey="expense">
//             <NavIcon>
//                 <i className="bi bi-currency-exchange" style={{ fontSize: '1.50em' }} />
//             </NavIcon>
//             <NavText style={{ fontSize: '1.10em',fontFamily:"serif",fontWeight:"bolder" }}>
//               CATEGORY MASTER
//             </NavText>
//         </NavItem>
//         <NavItem eventKey="credential">
//             <NavIcon>
//                 <i className="bi bi-cash-coin" style={{ fontSize: '1.50em' }} />
//             </NavIcon>
//             <NavText style={{ fontSize: '1.05em',fontFamily:"serif",fontWeight:"bolder" }}>
//                 SUPPLIER MASTER
//             </NavText>
//             {/* <NavItem eventKey="charts/linechart">
//                 <NavText>
//                     Line Chart
//                 </NavText>
//             </NavItem>
//             <NavItem eventKey="charts/barchart">
//                 <NavText>
//                     Bar Chart
//                 </NavText>
//             </NavItem> */}
//         </NavItem>
//         <NavItem eventKey="location">
//             <NavIcon>
//             <i class="bi bi-geo-alt-fill" style={{ fontSize: '1.50em' }}></i>
//             </NavIcon>
//             <NavText style={{ fontSize:'1.03em',fontFamily:"serif",fontWeight:"bolder" }}>
//               RAW MATERIAL MASTER
//             </NavText>
//         </NavItem>
//         <NavItem eventKey="subscription">
//             <NavIcon>
//             <i class="bi bi-collection-play" style={{ fontSize: '1.50em' }}></i>
//             </NavIcon>
//             <NavText style={{ fontSize:'1.03em',fontFamily:"serif",fontWeight:"bolder" }}>
//               EXPENSE LOG
//             </NavText>
//         </NavItem>
//         <NavItem eventKey="paymode">
//             <NavIcon>
//             <i class="bi bi-credit-card" style={{ fontSize: '1.50em' }}></i>
//             </NavIcon>
//             <NavText style={{ fontSize:'1.03em',fontFamily:"serif",fontWeight:"bolder" }}>
//               PAYMODE MASTER
//             </NavText>
//         </NavItem>
//         <NavItem eventKey="credituser">
//             <NavIcon>
//             <i class="bi bi-credit-card" style={{ fontSize: '1.50em' }}></i>
//             </NavIcon>
//             <NavText style={{ fontSize:'1.03em',fontFamily:"serif",fontWeight:"bolder" }}>
//               CREDIT USERS
//             </NavText>
//         </NavItem>
//         <NavItem onClick={() => setIsUsermanagementOpen(!isUsermanagementOpen)}>
//             <NavIcon>
//               <i className="bi bi-folder-fill" style={{ fontSize: '1.50em' }} />
//             </NavIcon>
//             <NavText style={{ fontSize: '0.9em', fontFamily: "serif", fontWeight: "bold", padding: '2px 0',margin:"0px" }}>
//               User Management
//             </NavText>
//           </NavItem>

//           <Collapse in={isUsermanagementOpen}>
//             <div>
//               <NavItem eventKey="createemp">
//                 <NavIcon>
//                   <i className="bi bi-currency-exchange" style={{ fontSize: '1.50em' }} />
//                 </NavIcon>
//                 <NavText style={{ fontSize: '0.9em', fontFamily: "serif", fontWeight: "bold", padding: '2px 0',margin:"0px" }}>
//                   CREATE EMPLOYEE
//                 </NavText>
//               </NavItem>
//               <NavItem eventKey="createrol">
//                 <NavIcon>
//                   <i className="bi bi-cash-coin" style={{ fontSize: '1.50em' }} />
//                 </NavIcon>
//                 <NavText style={{ fontSize: '0.9em', fontFamily: "serif", fontWeight: "bold", padding: '2px 0',margin:"0px" }}>
//                   CREATE ROLE
//                 </NavText>
//               </NavItem>
//               </div>
//               </Collapse>
//         </SideNav.Nav>
//       </SideNav>
//       <div className="content">
//         {/* Main content goes here */}
//         {/* Add other components or content here */}
//       </div>
//     </div>
//   );
// };

// export default Layout;

import React, { useState } from 'react';
import SideNav, { NavItem, NavIcon, NavText } from '@trendmicro/react-sidenav';
import { useHistory } from 'react-router-dom';
// import './Layout.css'; // Optional: Your layout styles

const AppSidebar = () => {
  const [selected, setSelected] = useState("dashboard");
  const [isUsermanagementOpen, setIsUsermanagementOpen] = useState(false);
  const [isCategoryManagement, setIsCategoryManagement] = useState(false);
  const [isCreditUser, setIsCreditUser] = useState(false);
  const [isOpenSlot, setIsOpenSlot] = useState(false);
  const [isOrderManage, setIsOrderManage] = useState(false);
  const history = useHistory();
  const [isMastersOpen, setIsMasterOpen] = useState(false);
  const [isSidebarOpen, setIsSidebarOpen] = useState(false);

  const handleSelect = (selectedItem) => {
    setSelected(selectedItem);
    switch (selectedItem) {
      case 'dashboard':
        history.push('/superadmin-dashboard');
        break;
      case 'credential':
        history.push('/Adminsupplier-master');
        break;
      case 'rolemaster':
        history.push('/superadmin-role');
        break;
      case 'empmaster':
        history.push('/superadmin-employee');
        break;
      case 'overalldayclosing':
        history.push('/overall-day-closing')
      default:
        break;
    }
  };
  const handleToggleSidebar = () => {
    // Toggle sidebar visibility
    setIsSidebarOpen(!isSidebarOpen);
    // Set isCategoryManagement to false when toggling the sidebar
    setIsCategoryManagement(false);
    setIsCreditUser(false);
    setIsOpenSlot(false);
    setIsOrderManage(false);
    setIsMasterOpen(false);
    setIsUsermanagementOpen(false);

  };

  return (
    <div className="layout">
      <SideNav onSelect={handleSelect}  style={{
    position: "fixed",       // Fixes the position of the sidebar
    top: 0,                  // Aligns it to the top of the viewport
    left: 0,                 // Aligns it to the left of the viewport
    height: "200vh",         // Ensures it spans the full viewport height
    backgroundColor: "#f02929",
    overflowY: "scroll",     // Enables vertical scrolling
    maxHeight: "100vh",      // Keeps sidebar within viewport height
    scrollbarWidth: "none",  // Hides scrollbar in Firefox
  }} className="sidebar"
  expanded={isSidebarOpen} // Controls the sidebar open/close state
      onToggle={handleToggleSidebar} >
        <SideNav.Toggle onClick={handleToggleSidebar}/>
        <SideNav.Nav style={{maxHeight:"200vh"}}>
          <NavItem eventKey="dashboard">
            <NavIcon>
              <i className="bi bi-house" style={{ fontSize: '1.50em' }} />
            </NavIcon>
            <NavText style={{ fontSize: '0.9em', fontFamily: "serif", fontWeight: "bold", padding: '2px 0',margin:"0px" }}>
              DASHBOARD
            </NavText>
          </NavItem>

        

         <NavItem eventKey="shopmanagement">
            <NavIcon>
              <i className="bi bi-geo-alt-fill" style={{ fontSize: '1.50em' }} />
            </NavIcon>
            <NavText style={{ fontSize: '0.9em', fontFamily: "serif", fontWeight: "bold", padding: '2px 0',margin:"0px" }}>
              SHOP MANAGEMENT
            </NavText>
          </NavItem>

          <NavItem eventKey="rolemaster">
            <NavIcon>
              <i className="bi bi-collection-play" style={{ fontSize: '1.50em' }} />
            </NavIcon>
            <NavText style={{ fontSize: '0.9em', fontFamily: "serif", fontWeight: "bold", padding: '2px 0',margin:"0px" }}>
            ROLE MASTER
            </NavText>
          </NavItem>

          <NavItem eventKey="empmaster">
            <NavIcon>
              <i className="bi bi-collection-play" style={{ fontSize: '1.50em' }} />
            </NavIcon>
            <NavText style={{ fontSize: '0.9em', fontFamily: "serif", fontWeight: "bold", padding: '2px 0',margin:"0px" }}>
            EMPLOYEE MASTER
            </NavText>
          </NavItem>

          <NavItem eventKey="overalldayclosing">
            <NavIcon>
              <i className="bi bi-collection-play" style={{ fontSize: '1.50em' }} />
            </NavIcon>
            <NavText style={{ fontSize: '0.9em', fontFamily: "serif", fontWeight: "bold", padding: '2px 0',margin:"0px" }}>
            OVERALL DAY CLOSING
            </NavText>
          </NavItem>

        </SideNav.Nav>
      </SideNav>

      <div className="content">
        {/* Main content goes here */}
      </div>
    </div>
  );
};

export default AppSidebar;

